import { render, staticRenderFns } from "./FilteredList.vue?vue&type=template&id=4a2e08c9&lang=pug&"
import script from "./FilteredList.vue?vue&type=script&lang=ts&"
export * from "./FilteredList.vue?vue&type=script&lang=ts&"
import style0 from "./FilteredList.vue?vue&type=style&index=0&id=4a2e08c9&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports